<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('viewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogViewForm"
          :model="dialogViewForm"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="出库仓库">
                    <el-input
                      v-model="dialogViewForm.depotName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="出库类型">
                    <el-input
                      v-model="dialogViewForm.outdepotTypeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.outdepotType === 13"
                  :span="6"
                >
                  <el-form-item label="调入仓库">
                    <el-input
                      v-model="dialogViewForm.transferDepotName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogViewForm.schemeId > 0"
                :gutter="10"
              >
                <el-col :span="18">
                  <el-form-item label="方案名称">
                    <el-input
                      v-model="dialogViewForm.schemeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="方案编号">
                    <el-input
                      v-model="dialogViewForm.schemeNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="出库时间">
                    <el-date-picker
                      v-model="dialogViewForm.outdepotDateStr"
                      disabled
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="经办人">
                    <el-input
                      v-model="dialogViewForm.operater"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="物料使用人">
                    <el-input
                      v-model="dialogViewForm.receiver"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="状态">
                    <el-input
                      v-model="dialogViewForm.statusStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              物料信息
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="materialListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      align="center"
                      width="60"
                    />
                    <el-table-column
                      prop="schemeName"
                      label="方案名称"
                      header-align="center"
                      show-overflow-tooltip
                    />
                    <el-table-column
                      prop="materialsName"
                      label="物料名称"
                      header-align="center"
                      show-overflow-tooltip
                      width="240"
                    />
                    <el-table-column
                      prop="sourceTypeStr"
                      label="物料来源"
                      align="center"
                      width="80"
                    />
                    <el-table-column
                      prop="unitName"
                      label="单位"
                      align="center"
                      width="60"
                    />
                    <!-- <el-table-column
                      prop="price"
                      label="单价"
                      width="80"
                    /> -->
                    <el-table-column
                      prop="amount"
                      label="数量"
                      align="center"
                      width="80"
                    />
                    <!-- <el-table-column
                      prop="total"
                      label="合计"
                      align="center"
                      width="80"
                    /> -->
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-if="isViewPic"
            class="modal-box"
          >
            <h3 class="modal-title">
              附件信息
            </h3>
            <div class="modal-row-box">
              <div class="demo-input-suffix">
                <show-preview :arr-file-data="picList" />
              </div>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              操作备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item label="备注">
                    <el-input
                      v-model="dialogViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="操作人">
                    <el-input
                      v-model="dialogViewForm.operatorName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="操作时间">
                    <el-input
                      v-model="dialogViewForm.operationTimeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 图片预览
import showPreview from '@/components/showPreview'
// 权限验证
import checkPermission from '@/utils/permission'
// 数据请求
import { initOutdepotBillApi, initOutdepotBillDetailApi } from '@/api/outdepotBill'
import { findAttachmentInfoByConditionApi } from '@/api/common'

export default {
  components: { showPreview },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogViewForm: {},
      materialListData: [],
      picList: [],
      baseUrl: '',

      //是否有权查看出库
      isViewPic: false
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.loading = true

        this.dialogViewForm = {}
        this.materialListData = []
        this.picList = []
        this.baseUrl = process.env.VUE_APP_BASE_API
        this.isViewPic = false
        if (checkPermission(['outdepot_pic_view'])) {
          this.isViewPic = true
        }
        this.initData()
        this.initPicData()
      }
    }
  },
  methods: {
    // 加载数据
    initData() {
      initOutdepotBillApi({ id: this.dataId }).then(res => {
        const { data } = res
        this.dialogViewForm = data
        this.initDetailData()
      })
    },
    initDetailData() {
      let noViewSmoke = 1
      if (checkPermission(['sample_smoke_view'])) {
        noViewSmoke = 0
      }
      initOutdepotBillDetailApi({ outdepotId: this.dataId, noViewSmoke: noViewSmoke }).then(res => {
        const { data } = res
        this.materialListData = data || []
        this.loading = false
      })
    },
    initPicData() {
      findAttachmentInfoByConditionApi({ sourceType: 4, sourceId: this.dataId }).then(res1 => {
        if (res1.data && res1.data.length > 0) {
          res1.data.forEach(item => {
            let obj = {}
            obj.name = item.attachmentName
            obj.url = this.baseUrl + item.attachmentUrl
            obj.attachmentName = item.attachmentName
            obj.attachmentUrl = item.attachmentUrl
            this.picList.push(obj)
          })
        }
      })
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogViewForm.clearValidate()
    }
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
  .cell {
    line-height: 16px;
  }
}
</style>
